import { Controller } from "react-hook-form";

import { FieldError, Label } from "@/components/field";
import {
  Select,
  SelectButton,
  SelectListBox,
  SelectListItem,
  SelectPopover,
} from "@/components/select";
import { COMPLEXITY_OPTIONS } from "@/features/shared/constants/complexityConstants";

import { useCreateWebsiteDesignRequestFormContext } from "../useCreateWebsiteDesignRequestForm";

export function ComplexitySelect() {
  const methods = useCreateWebsiteDesignRequestFormContext();

  return (
    <Controller
      control={methods.control}
      name="designComplexityId"
      render={({
        field: { name, onBlur, onChange, value },
        fieldState: { error, invalid },
      }) => (
        <Select
          className="col-span-4"
          isInvalid={invalid}
          name={name}
          onBlur={onBlur}
          onSelectionChange={onChange}
          placeholder="Select design complexity"
          selectedKey={value}
        >
          <Label requiredHint>Design complexity</Label>
          <SelectButton />
          <SelectPopover>
            <SelectListBox>
              {COMPLEXITY_OPTIONS.map(({ id, name }) => (
                <SelectListItem id={id} key={id}>
                  {name}
                </SelectListItem>
              ))}
            </SelectListBox>
          </SelectPopover>
          <FieldError>{error?.message}</FieldError>
        </Select>
      )}
    />
  );
}
